var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgCaretDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5479 11.8775C25.9931 11.5507 26.619 11.6467 26.9458 12.0919C27.2726 12.5371 27.1766 13.163 26.7314 13.4898L16.6021 21C16.2013 21.2941 15.9457 21.3372 15.6021 21L5.40832 13.4898C4.96311 13.163 4.86713 12.5371 5.19395 12.0919C5.52076 11.6467 6.14661 11.5507 6.59182 11.8775L16.0699 18.8351L25.5479 11.8775Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgCaretDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/caret-down.aad751d0947ccbd7bc1b3521248bed4c.svg";